export class ReportPublicationCommand {
    publicationId: string;
    reason: string;

    constructor(publicationId: string, reason: string) {
        this.publicationId = publicationId;
        this.reason = reason;
    }
}
